module.exports = __webpack_public_path__ + "img/DAY1-3.412d1075.jpg";